// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTA-module--cta--3iSwj"};